<template>
  <div>
    <slot></slot>
    <!--    Change <property> to <value>, <property> to <value>, and <property> to <value> when <condition>-->
    {{propertyUpdatesDescription(objectModelTrigger.propertyUpdatesArray)}}
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import triggerBaseMixin from "../mixins/trigger-base-mixin";
  import {RouteHelper} from "../../../common/helpers/routeHelper";
  import {Route} from "~/enums/route";
  import propertyUpdateMixin from "../mixins/propertyUpdateMixin";
  import selectedMixin from "../mixins/selectedMixin";

  export default Vue.extend({
    components: {},
    mixins: [
      triggerBaseMixin,
      propertyUpdateMixin,
      selectedMixin
    ],
    computed: {},
    methods: {
      displayJoiner(index): string{
        let length = this.objectModelTrigger.propertyUpdatesArray.length;
        if (index === length-1){
          return ""
        }else if (index === length - 2 ){
          return ", and "
        } else{
          return ", "
        }
      }
    },
    data: function () {
      return {
        RouteHelper,
        Route,

      };
    },
  });
</script>